import { render, staticRenderFns } from "./AboutPageCms.vue?vue&type=template&id=db1474e6&scoped=true"
import script from "./AboutPageCms.vue?vue&type=script&lang=js"
export * from "./AboutPageCms.vue?vue&type=script&lang=js"
import style0 from "./AboutPageCms.vue?vue&type=style&index=0&id=db1474e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1474e6",
  null
  
)

export default component.exports